<template>
  <div class="login">
    <div class="content">
      <h3 style="color: #409eff;">高德优选 后台管理</h3>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="account">
          <el-input
            type="text"
            v-model="ruleForm.account"
            prefix-icon="el-icon-user"
            placeholder="请输入账号"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
          />
        </el-form-item>

        <!-- 图形验证码 -->
        <el-form-item prop="captcha">
          <div class="captcha-wrapper">
            <el-input
              v-model="ruleForm.captcha"
              prefix-icon="el-icon-key"
              placeholder="请输入验证码"
              class="captcha-input"
            />
            <div class="captcha-image" @click="refreshCaptcha">
              <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
              <span v-else>加载中...</span>
              <!-- <i class="el-icon-refresh-right refresh-icon"></i> -->
            </div>
          </div>
        </el-form-item>

        <el-form-item label="">
          <el-checkbox v-model="checked">记住我</el-checkbox>
        </el-form-item>
        <el-button type="primary" @click="Login" :loading="loading">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import axios from 'axios'

// 创建独立的 axios 实例，用于验证码请求（携带凭证）
const captchaRequest = axios.create({
  withCredentials: true,
  responseType: 'arraybuffer'
})

// 登录请求实例
const loginRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

export default {
  name: 'Login',
  data () {
    return {
      ruleForm: {
        account: '',
        password: '',
        captcha: '' // 用户输入的验证码
      },
      checked: false,
      loading: false,
      captchaUrl: '', // 验证码图片 base64
      serverCaptcha: '', // 服务端验证码值（从响应头获取）
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // 读取记住的账号密码
    if (Cookie.get('checked') === 'true') {
      this.checked = true
      this.ruleForm.account = Cookie.get('account') || ''
      this.ruleForm.password = Cookie.get('password') || ''
    }
    // 加载验证码
    this.refreshCaptcha()
  },
  methods: {
    // 刷新图形验证码
    async refreshCaptcha () {
      try {
        const res = await captchaRequest.get('https://api.gd.91comerp.com/index/get_captcha.php', {
          params: { t: Date.now() }
        })
        // 从响应头获取服务端验证码文本（用于后端校验）
        const verifyCode = res.headers['x-verify-code'] || res.headers['X-Verify-Code']
        console.log(verifyCode)
        if (verifyCode) {
          this.serverCaptcha = verifyCode
        } else {
          console.warn('未获取到验证码标识')
        }
        // 将二进制图片转为 base64
        const base64 = btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
        this.captchaUrl = `data:image/png;base64,${base64}`
      } catch (error) {
        console.error('获取验证码失败', error)
        this.$message.error('验证码加载失败，请刷新重试')
      }
    },

    // 登录提交
    Login () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        this.loading = true

        try {
          // 调用新登录接口（与小程序一致）
          const response = await loginRequest.post('https://api.gd.91comerp.com/index/login_pc.php',
            new URLSearchParams({
              username: this.ruleForm.account,
              password: this.ruleForm.password,
              captcha: this.ruleForm.captcha,
              ser_captcha: this.serverCaptcha || this.ruleForm.captcha,
              user_type: 'wholesaler' // 后台管理默认批发商身份
            }).toString()
          )

          const res = response.data
          if (res.code === 200) {
            // 登录成功处理
            if (this.checked) {
              Cookie.set('account', this.ruleForm.account, { expires: 7 })
              Cookie.set('password', this.ruleForm.password, { expires: 7 })
              Cookie.set('checked', 'true', { expires: 7 })
            } else {
              Cookie.remove('account')
              Cookie.remove('password')
              Cookie.remove('checked')
            }
            // 存储 token 及用户信息（可根据后端返回字段扩展）
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('user_name', this.ruleForm.account)
            Cookie.set('token', res.data.token, { expires: 3 }) // token 有效期3天
            // 可选存储其他必要信息，如 user_type、user_id 等
            if (res.data.userid) localStorage.setItem('user_id', res.data.userid)
            if (res.data.user_type) localStorage.setItem('user_type', res.data.user_type)

            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/'
            this.$router.push(redirect)
          } else {
            this.$message.error(res.message || '登录失败，请检查账号或验证码')
            // 验证码错误时刷新
            this.refreshCaptcha()
            this.ruleForm.captcha = ''
          }
        } catch (error) {
          console.error('登录异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.ruleForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  background: url("~@/assets/image/01.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  border-radius: 6px;
  background: rgba(255,255,255,0.95);
  width: 420px;
  padding: 30px 30px 20px 30px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  h3 {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
    color: red;
  }
}
.el-form-item {
  margin-top: 20px;
}
.el-button--primary {
  width: 100%;
  margin-bottom: 10px;
}
.captcha-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  .captcha-input {
    flex: 1;
  }
  .captcha-image {
    // width: 120px;
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #f5f7fa;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .refresh-icon {
      position: absolute;
      right: 4px;
      bottom: 4px;
      font-size: 14px;
      color: #909399;
      background: rgba(255,255,255,0.7);
      border-radius: 50%;
      padding: 2px;
    }
    &:hover .refresh-icon {
      color: #409eff;
    }
  }
}
</style>
